<template>
  <el-dialog title="Produkt einem Lieferanten zuweisen" :visible="show" @close="close"
    width="30%"
  >
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <div class="form-group has-label">
            <label>Lieferant</label>
            <multiselect v-model="supplier"
              :options="suppliers"
              track-by="id"
              label="name"
            />
          </div>
          <fg-input label="Preis"
            type="text"
            :value="price"
            @input="price = $event"
            :error="valErrors['price'] ? valErrors['price'][0] : null"
          />
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary"
              :disabled="! canSubmit"
            >
              Zuweisen
            </button>
            <button class="btn btn-fill btn-default"
              @click.prevent="close"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import priceWatcher from './price-watcher'

export default {
  props: ['show', 'suppliers', 'valErrors', 'initPrice'],
  components: { [Dialog.name]: Dialog },
  mixins: [priceWatcher],
  data () {
    return {
      supplier: null,
      supplierPrice: this.initPrice
    }
  },
  computed: {
    canSubmit () {
      return this.supplier && this.supplierPrice
    }
  },
  methods: {
    getPrice () {
      return this.supplierPrice
    },
    setPrice (price) {
      this.supplierPrice = price
    },
    submit () {
      this.$emit('assignToSupplier', {
        supplier_id: this.supplier ? this.supplier.id : null,
        price: this.supplierPrice
      })
    },
    close () {
      this.$emit('close')
      this.supplier = null
      this.supplierPrice = this.initPrice
    }
  }
}
</script>

<style>
</style>
